import { render, staticRenderFns } from "./AamsRegSealAuthRecord.vue?vue&type=template&id=d2a9be0e&scoped=true&"
import script from "./AamsRegSealAuthRecord.vue?vue&type=script&lang=js&"
export * from "./AamsRegSealAuthRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a9be0e",
  null
  
)

export default component.exports